export default "__VITE_ASSET__BWQAy53P__"